import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';
import type { IPolicies } from '@/modules/policies/helpers';
import { type CMSApiBase, createCmsUrl } from './base';

export interface PrivacyPolicyApi extends CMSApiBase, IPolicies {
  title: string;
  titleH1: string;
  lastUpdated: string;
  tableHtml?: string;
}

export const getPrivacyPolicyUrl = (lang: string) =>
  createCmsUrl({
    path: 'privacy-policy',
    queryData: { ...getCMSLocale(lang) },
  });

export const fetchPrivacyPolicy = async (lang: string) =>
  fetcherCMS<PrivacyPolicyApi>(getPrivacyPolicyUrl(lang));
